/**
 * URL strings shown in tables and modals: keep http(s) when present;
 * otherwise prefix https:// so the full navigable URL is visible.
 */
export function toDisplayUrl(raw: string | null | undefined): string {
  const s = String(raw ?? "").trim()
  if (!s || s.toLowerCase() === "n/a") return ""
  if (/^https?:\/\//i.test(s)) return s
  return `https://${s}`
}

export function toAbsoluteUrlHref(raw: string | null | undefined): string {
  const d = toDisplayUrl(raw)
  return d || "#"
}
